import { useCreateEditSurveyMutation } from "../../../../../api/surveys/useCreateEditSurveyMutation";
import { SETTINGS_ROUTES } from "../../../../../consts/routes";
import { history } from "../../../../../history";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";
import {
  blockAdapter,
  getPathParams,
  groupErrors,
  preSubmitValidation,
} from "../utilities";

export const useSubmit = ({ blockErrors, blockListRef }) => {
  const { surveyId, isEditMode } = getPathParams();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { mutateAsync, isLoading } = useCreateEditSurveyMutation({
    onSuccess: () => {
      if (isEditMode) {
        uiNotification.success(t("success.update"));
      } else {
        uiNotification.success(t("success.create"));
      }
      history.push(SETTINGS_ROUTES.surveys() + "?skipPrompt=true");
    },
    onError: (res) => {
      const message = extractApiError(res);
      if (isEditMode) {
        uiNotification.error(t([`error.${message}`, "error.update"]));
      } else {
        uiNotification.error(t([`error.${message}`, "error.create"]));
      }
    },
  });

  return {
    initiate: ({ title, questions }) => {
      blockErrors.clear();

      var errors = preSubmitValidation({ title, questions });
      var error = errors[0];

      if (error) {
        blockListRef.scrollTo(error.elementId);
        blockErrors.set(groupErrors(errors));
        uiNotification.error(t("error.validationError"));
        return;
      }

      return mutateAsync({
        id: isEditMode ? surveyId : null,
        title,
        questions: questions.map((block, index) =>
          blockAdapter.send(block, index + 1, isEditMode),
        ),
      });
    },
    isLoading,
  };
};
